package com.schoolconnect.app.feature.splash

data class SplashUiState(
    val appName: String = "iConnect.School",
    val headline: String = "Restoring your school workspace",
    val subtitle: String = "Checking your saved session and loading the latest data.",
    val status: String = "Please wait while we prepare your dashboard.",
    val footerNote: String = "Secure access. Fast sync. No login flash."
)

sealed interface SplashUiEvent
